module.exports = __webpack_public_path__ + "static/media/Regice_gaussian2.5ad130ef.png";